/* eslint-disable @typescript-eslint/no-explicit-any */
import {
    INITIAL_USER,
    NO_THANKS_BUTTON_ROLE,
    USUAL_MODE,
    VALIDATE_BUTTON_ROLE,
    VALIDATED_EXTENSION_FILE,
} from "@constants";
import { t } from "i18next";
import { useSnapshot } from "valtio";

import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { getImageContentById } from "@helpers/general";

import { DynamicSvgComponent } from "@components/DynamicSvgComponent";
import { MenuIcon } from "@components/OrderTaking/Components/Icons/MenuIcon";
import {
    addResetUserRewards,
    addRewardsItems,
    cancelUserGifts,
    clearReward,
    setUsedGifts,
} from "@components/OrderTaking/Store/feature";

import {
    kioskStore,
    setIsCustomerBenefitOnClick,
    setIsCustomerBenefitOpen,
    setIsPrm,
    setIsUserAuthenticated,
    setUser,
} from "@pages/Kiosk/store";

import "./promo.css";
import {
    PrmImgSwitcher,
    PrmLoyaltyActionsListContainer,
    PrmMenuIcon,
} from "./styledCss";

type footerType = {
    prmSectionDisplay: {
        isPrmReward: boolean;
        isPrmGift: boolean;
    };
    setPrmSectionDisplay: React.Dispatch<
        React.SetStateAction<{
            isPrmReward: boolean;
            isPrmGift: boolean;
        }>
    >;
    setIsPrmPromoModelOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function Footer({
    setPrmSectionDisplay,
    prmSectionDisplay,
    setIsPrmPromoModelOpen,
}: footerType): JSX.Element {
    const dispatch = useDispatch();
    const {
        project: {
            template: {
                content,
                pages: {
                    subSteps: {
                        customerBenefit: {
                            options: { nothanksButton },
                        },
                    },
                },
            },
        },
        isPrm,
    } = useSnapshot(kioskStore);
    const { userRewards, userGifts } = useSelector(
        (state: any) => state.orderSlice
    );
    const [initialReward] = React.useState(userRewards);

    const { actionsButtons } = useSelector(
        (state: any) => state.settingSlice.generalSetting
    );

    const noThanksButton = actionsButtons.find(
        (item: any) => item.active && item.role === NO_THANKS_BUTTON_ROLE
    );
    const validateButton = (
        content.actionsButtons as ActionsButtonsDesignType
    ).items.filter((item: any) => item.role === VALIDATE_BUTTON_ROLE)[0];

    const validateImageSrc = getImageContentById(validateButton.id);
    const noThnxImageSrc = getImageContentById(noThanksButton.id);

    const handleValidateOnClickEvent = () => {
        dispatch(addRewardsItems());

        const selectedCode =
            userGifts.filter((item: any) => item.isSelected) || [];
        dispatch(setUsedGifts(selectedCode));

        setIsCustomerBenefitOpen(false);
        setIsCustomerBenefitOnClick(false);
    };

    const closeModal = () => {
        setIsCustomerBenefitOpen(false);
        setIsCustomerBenefitOnClick(false);
        dispatch(addResetUserRewards({ ...initialReward, isClose: true }));
        dispatch(cancelUserGifts());
    };

    return (
        <div
            className="centered-items w-100 position-absolute"
            style={{ height: "100px", bottom: "1rem" }}
        >
            {nothanksButton ? (
                noThnxImageSrc ? (
                    <div
                        className="additional-sale-button mx-3"
                        onClick={closeModal}
                    >
                        {VALIDATED_EXTENSION_FILE.includes(
                            noThnxImageSrc.slice(-4)
                        ) ? (
                            <img
                                alt="No thank you button"
                                src={noThnxImageSrc}
                                style={{ height: "87px", width: "350px" }}
                            />
                        ) : (
                            <DynamicSvgComponent
                                nameSvg={noThnxImageSrc}
                                width={"350px"}
                                height={"87px"}
                            />
                        )}
                    </div>
                ) : (
                    <button
                        className="additional-sale-button mx-2"
                        style={{ background: `var(--global-color)` }}
                        onClick={closeModal}
                    >
                        <div className="text-button">{t("No thanks")}</div>
                    </button>
                )
            ) : null}

            {validateImageSrc ? (
                <div
                    className="additional-sale-button mx-3"
                    onClick={handleValidateOnClickEvent}
                >
                    {VALIDATED_EXTENSION_FILE.includes(
                        validateImageSrc.slice(-4)
                    ) ? (
                        <img
                            alt="validate button"
                            src={validateImageSrc}
                            style={{ height: "87px", width: "350px" }}
                        />
                    ) : (
                        <DynamicSvgComponent
                            nameSvg={validateImageSrc}
                            width={"350px"}
                            height={"87px"}
                        />
                    )}
                </div>
            ) : (
                <button
                    onClick={handleValidateOnClickEvent}
                    className="additional-sale-button"
                    style={{ background: `var(--global-color)` }}
                >
                    <div className="text-button">{t("Validate")}</div>
                </button>
            )}
            {isPrm ? (
                <PrmActionButton
                    setPrmSectionDisplay={setPrmSectionDisplay}
                    setIsPrmPromoModelOpen={setIsPrmPromoModelOpen}
                    isPrmGift={prmSectionDisplay.isPrmGift}
                />
            ) : null}
        </div>
    );
}

type prmActionButtonType = {
    setIsPrmPromoModelOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setPrmSectionDisplay: React.Dispatch<
        React.SetStateAction<{
            isPrmReward: boolean;
            isPrmGift: boolean;
        }>
    >;
    isPrmGift: boolean;
};

function PrmActionButton({
    setIsPrmPromoModelOpen,
    setPrmSectionDisplay,
    isPrmGift,
}: prmActionButtonType): JSX.Element {
    const [isActionListOpen, setIsActionListOpen] = React.useState(false);
    const { activeConfigOptions } = useSnapshot(kioskStore);
    const UsualModeOption = activeConfigOptions.filter(
        (config) => config.title.toLowerCase() === USUAL_MODE
    )[0];
    const imageSrc = getImageContentById(UsualModeOption.id);
    const handleClosePrmMode = () => {
        setIsPrm(false);
        setIsActionListOpen(false);
        setIsPrmPromoModelOpen(false);
        setPrmSectionDisplay({
            isPrmGift: false,
            isPrmReward: false,
        });
    };
    const handleCloseList = () => {
        setIsActionListOpen(!isActionListOpen);
    };

    return (
        <>
            {isActionListOpen ? (
                <PrmLoyaltyActionsListContainer isPrmGift={isPrmGift}>
                    <PrmActionsList
                        setIsActionListOpen={setIsActionListOpen}
                        setPrmSectionDisplay={setPrmSectionDisplay}
                        setIsPrmPromoModelOpen={setIsPrmPromoModelOpen}
                    />
                </PrmLoyaltyActionsListContainer>
            ) : null}
            <PrmImgSwitcher
                onClick={handleClosePrmMode}
                src={imageSrc}
                alt="button to switch between usual and prm mode"
            />
            <PrmMenuIcon
                onClick={handleCloseList}
                isActionListOpen={isActionListOpen}
            >
                <MenuIcon containerSize={90} iconSize={80} />
            </PrmMenuIcon>
        </>
    );
}

type prmActionsListType = {
    setIsActionListOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setIsPrmPromoModelOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setPrmSectionDisplay: React.Dispatch<
        React.SetStateAction<{
            isPrmReward: boolean;
            isPrmGift: boolean;
        }>
    >;
};

function PrmActionsList({
    setPrmSectionDisplay,
    setIsActionListOpen,
    setIsPrmPromoModelOpen,
}: prmActionsListType): any {
    const dispatch = useDispatch();
    const {
        project: {
            template: {
                pages: {
                    subSteps: {
                        customerBenefit: {
                            options: { rewards, promoCode, gifts },
                        },
                    },
                },
            },
        },
    } = useSnapshot(kioskStore);
    const actionList = [
        {
            title: t("My Rewards"),
            iconName: "rewardIcon",
            active: rewards.active,
        },
        { title: t("My gifts"), iconName: "promoCode", active: gifts.active },
        {
            title: t("Scan or enter Code Promo"),
            iconName: "scanPromoCode",
            active: promoCode.active,
        },
        { title: t("Log out"), iconName: "logOut", active: true },
    ];

    function handleLogoutUser() {
        dispatch(clearReward());
        dispatch(setUsedGifts([]));
        setIsUserAuthenticated(false);
        setUser(INITIAL_USER);
        setIsCustomerBenefitOpen(false);
        setIsCustomerBenefitOnClick(false);
        setIsActionListOpen(false);
        setIsPrmPromoModelOpen(false);
        setPrmSectionDisplay({
            isPrmGift: false,
            isPrmReward: false,
        });
    }

    function handleOnclickEvent(action: any) {
        switch (action.title) {
            case t("My Rewards"):
                setIsActionListOpen(false);
                setPrmSectionDisplay({
                    isPrmGift: false,
                    isPrmReward: true,
                });
                break;
            case t("My gifts"):
                setIsActionListOpen(false);
                setPrmSectionDisplay({
                    isPrmGift: true,
                    isPrmReward: false,
                });
                break;
            case t("Scan or enter Code Promo"):
                setIsPrmPromoModelOpen(true);
                setIsActionListOpen(false);
                setPrmSectionDisplay({
                    isPrmGift: true,
                    isPrmReward: false,
                });
                break;
            case t("Log out"):
                handleLogoutUser();
                break;
            default:
                break;
        }
    }

    return actionList.map((action, index) => {
        return action.active ? (
            <div
                key={index}
                className="d-flex flex-row align-items-center prm-action-button"
                onClick={() => handleOnclickEvent(action)}
            >
                <DynamicSvgComponent
                    nameSvg={action.iconName}
                    width={"30px"}
                    height={"30px"}
                />
                <span className="prm-action-list-text">{action.title}</span>
            </div>
        ) : null;
    });
}
